import { View } from "@react-pdf/renderer";
import { PDFStyleConfigs } from "../../../configs";

export const PDFTable = ({
  children,
  tableWidth = PDFStyleConfigs.TableWidth,
}: {
  children?: React.ReactNode;
  tableWidth?: string | number;
}) => {
  return (
    <View
      style={{
        gap: PDFStyleConfigs.GapXSmall,
        width: tableWidth,
      }}
    >
      {children}
    </View>
  );
};
